import React from 'react';
import './Current.css';
import { withCurrentData } from './withCurrentData';
import WeatherStation from '../Common/WeatherStation';
import HighsAndLows from './HighsAndLows';
import StationInfo from '../Common/StationInfo';
import { formatDateAndTime } from '../../helpers/format';

class Current extends React.Component {
  render() {
    return (
      <div id="Current">
        <StationInfo
          name={process.env.REACT_APP_STATION_NAME}
          latitude={process.env.REACT_APP_LATITUDE}
          longitude={process.env.REACT_APP_LONGITUDE}
          elevation={process.env.REACT_APP_ELEVATION}
        />
        <div className="current-weather">
          <div className="current-weather-header">
            <div className="title">Current Weather</div>
            <div className="date">Last Update: {formatDateAndTime(this.props.data.currentWeather.dateTime)}</div>
          </div>
          <WeatherStation
            weather={this.props.data.currentWeather}
            todaysRain={this.props.data.yearlyRainTotals[0]}
            lastFifteenMinutesRain={this.props.data.lastHourArchiveData
              .slice(0, 3)
              .reduce((sum, record) => sum + +record.rain, 0)}
            lastHoursRain={this.props.data.lastHourArchiveData.reduce(
              (sum, record) => sum + +record.rain,
              0
            )}
            stormTotal={this.props.data.stormTotal}
            twentyFourHourTempDifference={
              this.props.data.twentyFourHourTempDifference
            }
            barometerTrend={this.props.data.barometerTrend}
          />
        </div>
        <HighsAndLows highsAndLows={this.props.data.highsAndLows} />
      </div>
    );
  }
}

export default withCurrentData(Current);
